var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "login-pwd-reset" }, [
    _c("form", { attrs: { id: "login-form-" + _vm._uid, method: "post" } }, [
      _c("div", { class: { "modal-body": _vm.modalElement } }, [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-12" }, [
            _c(
              "div",
              { staticClass: "input-unit", attrs: { "data-validate": "mail" } },
              [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.username,
                      expression: "username"
                    }
                  ],
                  attrs: {
                    placeholder: _vm.$translate("Ceres::Template.loginEmail"),
                    type: "email",
                    name: "email",
                    autocomplete: "email",
                    id: "email" + _vm._uid,
                    "data-autofocus": ""
                  },
                  domProps: { value: _vm.username },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.username = $event.target.value
                    }
                  }
                })
              ]
            ),
            _vm._v(" "),
            _c("span", { staticClass: "error-msg" }, [
              _vm._v(
                _vm._s(_vm.$translate("Ceres::Template.loginEnterConfirmEmail"))
              )
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-12" }, [
            _c(
              "div",
              {
                staticClass: "input-unit",
                class: { "no-bottom": _vm.modalElement },
                attrs: { "data-validate": "text" }
              },
              [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.password,
                      expression: "password"
                    }
                  ],
                  attrs: {
                    placeholder: _vm.$translate(
                      "Ceres::Template.loginPassword"
                    ),
                    type: "password",
                    name: "password",
                    autocomplete: "current-password",
                    id: "password" + _vm._uid
                  },
                  domProps: { value: _vm.password },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.password = $event.target.value
                    }
                  }
                })
              ]
            ),
            _vm._v(" "),
            _c("span", { staticClass: "error-msg" }, [
              _vm._v(
                _vm._s(_vm.$translate("Ceres::Template.loginEmptyPassword"))
              )
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "mt-3",
          class: {
            "modal-footer justify-content-center": _vm.modalElement,
            row: !_vm.modalElement
          }
        },
        [
          _c(
            "div",
            {
              staticClass: "modal-footer-inner",
              class: { "col-12": !_vm.modalElement }
            },
            [
              _vm._t("extend-overlay-buttons"),
              _vm._v(" "),
              _c(
                "a",
                {
                  staticClass: "small text-appearance login-pwd-reset__button",
                  attrs: { href: "javascript:void(0)" },
                  on: { click: _vm.showResetPwdView }
                },
                [
                  _c(
                    "svg",
                    {
                      attrs: {
                        xmlns: "http://www.w3.org/2000/svg",
                        width: "10",
                        height: "10",
                        viewBox: "0 0 10 10"
                      }
                    },
                    [
                      _c("g", [
                        _c("g", [
                          _c("path", {
                            attrs: {
                              d:
                                "M9.43 4.714a4.716 4.716 0 0 1-9.43 0 4.716 4.716 0 0 1 9.43 0zM7.073 3.536c0-1.124-1.18-1.965-2.235-1.965-1 0-1.75.43-2.278 1.308a.193.193 0 0 0 .05.258l.81.614c.03.024.073.036.116.036a.195.195 0 0 0 .154-.073c.288-.369.411-.48.528-.565a.983.983 0 0 1 .528-.147c.393 0 .755.251.755.521 0 .32-.166.48-.54.651-.436.197-1.032.706-1.032 1.301v.221c0 .11.086.197.197.197h1.178c.11 0 .197-.086.197-.197 0-.14.178-.442.466-.607.467-.264 1.106-.62 1.106-1.553zM5.5 7.66V6.482a.194.194 0 0 0-.197-.196H4.126a.194.194 0 0 0-.197.196v1.179c0 .11.086.196.197.196h1.178c.11 0 .197-.086.197-.196z"
                            }
                          })
                        ])
                      ])
                    ]
                  ),
                  _vm._v(
                    "\n                    " +
                      _vm._s(
                        _vm.$translate("Ceres::Template.loginForgotPassword")
                      ) +
                      "?\n                "
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass:
                    "login-btn btn btn-primary btn-appearance btn-medium text-uppercase d-block",
                  attrs: { disabled: _vm.isDisabled },
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      return _vm.validateLogin($event)
                    }
                  }
                },
                [
                  _vm._v(
                    "\n                    " +
                      _vm._s(_vm.$translate("Ceres::Template.login")) +
                      "\n                    "
                  ),
                  _c("icon", {
                    attrs: { icon: "user", loading: _vm.isDisabled }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c("span", { staticClass: "login-or" }, [
                _vm._v(
                  "-- " +
                    _vm._s(_vm.$translate("TuningFanatics::Template.or")) +
                    " --"
                )
              ]),
              _vm._v(" "),
              _c(
                "a",
                {
                  staticClass:
                    "register-btn btn btn-primary btn-appearance btn-medium btn-primary--dark text-uppercase d-block",
                  attrs: { href: "/register", disabled: _vm.isDisabled }
                },
                [
                  _vm._v(
                    "\n                    " +
                      _vm._s(_vm.$translate("Ceres::Template.loginRegister")) +
                      "\n                    "
                  ),
                  _c("icon", {
                    attrs: { icon: "user", loading: _vm.isDisabled }
                  })
                ],
                1
              )
            ],
            2
          )
        ]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }